import {Injectable} from '@angular/core';

import * as APIM from '@common/utils/dist/models/api-messages.js';

import {Store} from '@stores/abstract-store';

/**
 * The latest attention event: the user's activity moved to a lesson item (a device connected or
 * a recording started on a data card, a trial was saved from it). Every chat message carries it
 * and the server applies each event once, so the chat follows the user even if it opens (or a
 * request is lost) later.
 */
@Injectable({
  providedIn: 'root',
})
export class AttentionStore extends Store<APIM.AgentAttention | null> {
  constructor() {
    super(null);
  }

  attend(
    key: string,
    name: string,
    kind: APIM.AgentAttentionKind,
    source: APIM.AgentAttention['source'],
  ) {
    // Strictly increasing, so two events in the same millisecond both apply
    const at = Math.max(Date.now(), (this.state()?.at ?? 0) + 1);
    this.setState({key, name, kind, source, at});
  }
}
